import { QueryClient, dehydrate, hydrate } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { canHydratePublicQuery } from "./lib/public-query-hydration";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    // Fixed for this document's lifetime; history changes do not change its CSP.
    // Undefined during SSR, where the response already gets its own policy.
    context: { queryClient, documentPathname: typeof window === "undefined" ? undefined : window.location.pathname, documentSession: { isAuthenticated: false } },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    dehydrate: () => ({ publicQueryState: JSON.stringify(dehydrate(queryClient, {
      shouldDehydrateQuery: canHydratePublicQuery,
      shouldDehydrateMutation: () => false,
    })) }),
    hydrate: (state: { publicQueryState?: string }) => {
      if (state.publicQueryState) hydrate(queryClient, JSON.parse(state.publicQueryState));
    },
  });

  return router;
};
